<template>
  <div class="row m-0">
    <div class="col-12 bold mb-1 pl-md-2" v-if="categoryItem != 'uncategorised' && filteredProducts.length > 0" :id="categories.id">
      {{categoryItem}}
    </div>
    <app-product-item v-for="prod in filteredProducts" :item="prod" :key="prod.id"></app-product-item>
  </div>
</template>

<script>
import ProductItem from '@/components/product/ProductItem.vue'

export default {
  props: ['categoryItem', 'search', 'products'],
  components: {
    appProductItem: ProductItem
  },
  data () {
    return {
      categories: {}
    }
  },
  mounted () {
    var stringVal = this.categoryItem
    var newStringVal = stringVal.replace(/ /g, '')
    var category = {
      id: newStringVal,
      cat: stringVal
    }
    this.categories = category
  },
  computed: {
    filteredProducts () {
      const search = this.search.toLowerCase().trim()
      return this.products.filter((product) => {
        if (product.disabled) {
          return false
        } else if (search) {
          return product.title.toLowerCase().indexOf(search) > -1
        } else {
          return true
        }
      })
    }
  }
}
</script>
